//import css
import "./scss/main.scss";

//import components js
import "./components/accordion/accordion.js";
import "./components/backtotop/backtotop.js";
import "./components/breadcrumbs/breadcrumbs.js";
import "./components/button/button.js";
import "./components/card-center/card-center.js";
import "./components/card-map/card-map.js";
import "./components/cards/cards.js";
import "./components/cols-3/cols-3.js";
import "./components/countdown/countdown.js";
import "./components/example/example.js";
import "./components/footer/footer.js";
import "./components/form-group/form-group.js";
import "./components/header/header.js";
import "./components/hero-small/hero-small.js";
import "./components/hero-title/hero-title.js";
import "./components/hero/hero.js";
import "./components/image-loader/image-loader.js";
import "./components/image/image.js";
import "./components/input/input.js";
import "./components/label/label.js";
import "./components/modal/modal.js";
import "./components/select/select.js";
import "./components/skiplinks/skiplinks.js";
import "./components/spinner/spinner.js";
import "./components/tab/tab.js";
import "./components/video-inline/video-inline.js";

import "./js/browser-detect";
import "./js/lazyload";
